"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class Namespaced {
  constructor(namespace, i18n, separator = '.') {
    this.namespace = namespace;
    this.i18n = i18n;
    this.separator = separator;
  }
  exists = (key, ...args) => {
    return this.i18n.exists(`${this.namespace}${this.separator}${key}`, ...args);
  };
  t = (key, ...args) => {
    return this.i18n.t(`${this.namespace}${this.separator}${key}`, ...args);
  };
  tIcon = (key, ...args) => {
    return this.i18n.tIcon(`${this.namespace}${this.separator}${key}`, ...args);
  };
  tArray = (key, ...args) => {
    return this.i18n.tArray(`${this.namespace}${this.separator}${key}`, ...args);
  };
  tIconArray = (key, ...args) => {
    return this.i18n.tIconArray(`${this.namespace}${this.separator}${key}`, ...args);
  };
  tf = (...args) => {
    return () => this.t(...args);
  };
  tfIcon = (...args) => {
    return () => this.tIcon(...args);
  };
  tfArray = (...args) => {
    return () => this.tArray(...args);
  };
  tfIconArray = (...args) => {
    return () => this.tIconArray(...args);
  };
  ns = key => {
    return new Namespaced(`${this.namespace}${this.separator}${key}`, this.i18n, this.separator);
  };
}
exports.default = Namespaced;